import PropTypes from 'prop-types'
import React from 'react'

const DEFAULT_CHECKMARK = {
  stroke: 'currentColor',
  strokeWidth: 7,
  fill: 'none',
}
const DEFAULT_CHECKBOX = {
  stroke: 'currentColor',
  strokeWidth: '6px',
  fill: 'none',
}

const CheckboxSVG = ({ size, checkmark, checkbox }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Checkmark</title>
    <g id="Rect" {...DEFAULT_CHECKBOX} {...checkbox}>
      <rect rx="15" ry="15" width="100" height="100" />
    </g>
    <g id="Check" {...DEFAULT_CHECKMARK} {...checkmark}>
      <line x1="45" x2="73" y1="67" y2="38" />
      <line x1="33" x2="50" y1="52" y2="67" />
    </g>
  </svg>
)

CheckboxSVG.defaultProps = {
  size: 24,
  checkmark: {},
  checkbox: {},
}

CheckboxSVG.propTypes = {
  size: PropTypes.number,
  checkmark: PropTypes.shape({}),
  checkbox: PropTypes.shape({}),
}

export default CheckboxSVG
